import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getVisitorCount } from "../services/commonServices";

export default function Footer() {

    const [visitorData, setVisitorData] = useState(null);

    useEffect(() => {
        const fetchVisitorCount = async () => {
            try {
                const data = await getVisitorCount();
                setVisitorData(data);
            } catch (error) {
                console.error("Error fetching visitor count:", error);
            }
        };

        fetchVisitorCount();
    }, []);

    return (
        <footer className="">
            <div className='footer-part'>
                <div className="container space-container">
                    <div className="row justify-content-between">

                        <div className="col-sm-12 col-xl-3">
                            <div className="footer-widget">
                                <a className="footer-logo" href="/home">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/elements/rep_dark.png`} alt="logo" />
                                </a>
                                <p className="footer-desc">
                                    Rashtriya e-Pustakalaya (राष्ट्रीय ई पुस्तकालय) is a
                                    digital initiative by the Department of School Education and Literacy, Ministry of
                                    Education, Government of India, for facilitating availability of quality digital books
                                    beyond the academic curricula across geographies, languages, genres and levels, and device
                                    agnostic accessibility.
                                </p>

                            </div>
                        </div>

                        <div className="col-sm-12 col-xl-8">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="footer-widget contact">
                                        <h5 className="footer-title">Information</h5>
                                        <div className="footer-links">
                                            <ul>
                                                <li><NavLink to="/about">About Us</NavLink></li>
                                                <li><NavLink to="/contact">Contact Us</NavLink></li>
                                                <li><NavLink to="/term_condition">Disclaimer</NavLink></li>
                                                <li><NavLink to="/privacy">Privacy Policy</NavLink></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <div className="footer-widget contact">
                                        <h5 className="footer-title">contact us</h5>
                                        <ul className="footer-contact">
                                            <li>
                                                <i className="icofont-ui-email"></i>
                                                <p>
                                                    <NavLink to="mailto:rashtriyaepustakalaya@gmail.com"> rashtriyaepustakalaya@gmail.com</NavLink>
                                                </p>
                                            </li>
                                            <li>
                                                <i className="fab fa-whatsapp"></i>
                                                <p>
                                                    <NavLink to="tel:9319703004">9319703004</NavLink>
                                                </p>
                                            </li>
                                            <li>
                                                <i className="icofont-location-pin"></i>
                                                <p>
                                                    <strong>Rashtriya e-Pustakalaya Secretariat</strong><br></br>
                                                    National Book Trust, India<br></br>
                                                    3rd Floor, 5 Institutional Area,
                                                    Phase-II,<br></br> Vasant Kunj, New Delhi – 110070
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="footer-widget contact">
                                        <h5 className="footer-title">Follow Us on</h5>
                                        <ul className="footer-social d-flex">
                                            <li>
                                                <NavLink className="twitter" to="https://x.com/e_pustakalaya?t=GZg3Fkx55JGt8pntIv9-Hg&s=09" target="_blank">
                                                    <div className='twitter social-icons'>
                                                        <svg id="twitter" xmlns="http://www.w3.org/2000/svg" width="15.044" height="14.08" viewBox="0 0 15.044 14.08">
                                                            <g id="layer1" transform="translate(-281.5 -167.31)">
                                                                <path id="path1009" d="M281.537,167.31l5.808,7.766L281.5,181.39h1.315l5.117-5.528,4.135,5.528h4.477l-6.135-8.2,5.44-5.877h-1.315l-4.713,5.091-3.808-5.091Zm1.934.969h2.057l9.081,12.142h-2.057Z" transform="translate(0 0)" fill="#414141" />
                                                                <rect id="Rectangle_47" data-name="Rectangle 47" width="4" height="12" transform="translate(0 6.118)" fill="#414141" />
                                                                <circle id="Ellipse_3" data-name="Ellipse 3" cx="2" cy="2" r="2" fill="#414141" />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink className="insta" to="https://www.instagram.com/rashtriyaepustakalaya?igsh=MXV2OHVvdzg5Y2FvcQ==" target="_blank">
                                                    <div className='social-icons insta-icon'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="17.5" viewBox="0 0 17.5 17.5">
                                                            <g id="instagram" transform="translate(-1.25 -0.884)">
                                                                <rect id="Rectangle_27976" data-name="Rectangle 27976" width="16" height="16" rx="5" transform="translate(2 1.634)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                                <path id="Path_160" data-name="Path 160" d="M16,11.37A4,4,0,1,1,12.63,8,4,4,0,0,1,16,11.37Z" transform="translate(-2.199 -2.167)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                                <line id="Line_15" data-name="Line 15" x2="0.01" transform="translate(14.115 5.518)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </NavLink>
                                            </li>
                                            <li className=''>
                                                <NavLink to="https://www.facebook.com/profile.php?id=61573994984759" target="_blank">
                                                    <div className="social-icons facebook-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z" /></svg>
                                                    </div>
                                                </NavLink>
                                            </li>
                                            <li className=''>
                                                <NavLink to="https://www.youtube.com/@Rashtriyae-Pustakalaya" target="_blank">
                                                    <div className="social-icons youtube-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" /></svg>
                                                    </div>
                                                </NavLink>
                                            </li>
                                            <li className=''>
                                                <NavLink to="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fshowcase%2Frashtriya-e-pustakalaya%2Fposts%3Flipi%3Durn%253Ali%253Apage%253Ad_flagship3_detail_base%253Ba9QGPK9jQJiDWS2lOzc86g%253D%253D" target="_blank">
                                                    <div className="social-icons linkdin-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" /></svg>
                                                    </div>
                                                </NavLink>
                                            </li>

                                        </ul>
                                        <h6 className="footer-title mb-2 mt-3">Implementing Agency</h6>
                                        <NavLink to="https://www.nbtindia.gov.in/" target='_blank'><img src={`${process.env.PUBLIC_URL}/assets/images/elements/nbt_light_mode.png`} className="implementing_agency" alt="NBT Logo" /> </NavLink>
                                    </div>
                                </div>





                            </div>

                        </div>


                    </div>


                </div>
            </div>
            <div className='footer_bottom'>
                <div className='container space-container'>
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-bottom">
                                <div className="newFooter--links newFooter--right">
                                    <p className='text-white me-2'>Site Visits</p>
                                    <div className='counterSec'>
                                        {visitorData?.data?.visitor_count != null && (
                                            <div className="d-flex">
                                                {String(visitorData.data.visitor_count)
                                                    .split("")
                                                    .map((digit, index) => (
                                                        <div key={index} className="count">
                                                            {digit}
                                                        </div>
                                                    ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <p className="footer-copytext text-center nbt-logo d-none">
                                    <span className='agency-name'>Implementing Agency</span>

                                </p>
                                <p className="footer-copytext text-center">
                                    <span> &copy; 2026 Rashtriya ePustakalaya. All Rights Reserved. </span> <br />
                                </p>
                                <div className='last_update'>Last Update : 23-10-2026</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
